__turbopack_context__.v({
  "fullWidth": "S7kBJW_fullWidth",
  "icon": "S7kBJW_icon",
});
